import { toDataSourceRequestString } from "@progress/kendo-data-query";
import { createApi } from "@reduxjs/toolkit/query/react";
import type { ListAdminProductsRequest, ListAdminRetailersResponse } from "../../contracts";
import { baseQueryAdminWithAuth } from "../api";

export const adminRetailerApi = createApi({
    reducerPath: "adminRetailerApi",
    baseQuery: baseQueryAdminWithAuth,
    endpoints: builder => ({
        listRetailers: builder.query<ListAdminRetailersResponse, ListAdminProductsRequest>({
            query: body => ({
                url: `retailer/list?${toDataSourceRequestString(body)}`,
                method: "POST",
                body
            })
        })
    })
});

export const {
    useListRetailersQuery,
    useLazyListRetailersQuery
} = adminRetailerApi;
